import { ReactNode } from "react";
import styled from "styled-components";
import { gray100, gray300, gray700, white } from "core/resources/theme/colors";

type Props = {
  title: string;
  iconSrc?: string;
  children?: ReactNode;
};

function WxCard({ title, iconSrc, children }: Props) {
  return (
    <Card>
      <Head>
        {iconSrc ? <HeadIcon src={iconSrc} alt="" /> : null}
        <Title>{title}</Title>
      </Head>
      <Body>{children}</Body>
    </Card>
  );
}

export default WxCard;

const Card = styled.article`
  border: 1px solid ${gray300};
  border-radius: 8px;
  min-width: 0;
  overflow: hidden;
`;

const Head = styled.header`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px 0;
`;

const HeadIcon = styled.img`
  width: 45px;
  height: 45px;
  flex-shrink: 0;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${gray700};
`;

const Body = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px;
  padding: 8px 10px 12px;
  align-items: stretch;
  background: ${white};
`;
